import { AxiosResponse } from 'axios';
import { IService } from '../shared/interfaces/service-interfaces';
import api from './api';

export interface IFetchServiceParams {
  company?: string;
  company_id?: string;
}
interface IServiceService {
  create: (data: Omit<IService, 'id'>) => Promise<AxiosResponse<IService>>;
  update: (
    serviceId: string,
    data: Partial<IService>,
  ) => Promise<AxiosResponse<IService>>;
  list: (params?: IFetchServiceParams) => Promise<AxiosResponse<IService[]>>;
  delete: (serviceId: string) => Promise<AxiosResponse>;
}

const serviceService: IServiceService = {
  create: data => api.post('/service/register_service', data),
  update: (serviceId, data) =>
    api.patch(`/service/update_service/${serviceId}`, data),
  list: params => api.get('/service/list_service', { params }),
  delete: serviceId => api.delete(`/service/delete_service/${serviceId}`),
};

export default serviceService;
